import "../scss/styles.scss";
import PageCommon from "./pages/PageCommon.js";
import PageDefault from "./pages/PageDefault.js";
import PageGeneric from "./pages/PageGeneric.js";
import PageLookupGroup from "./pages/lookup/PageLookupGroup.js";
import PageLookupList from "./pages/lookup/PageLookupList.js";
import PageLookupDetail from "./pages/lookup/PageLookupDetail.js";
import PageUsersList from "./pages/users/PageUsersList.js";
import PageUserDetail from "./pages/users/PageUserDetail.js";
import PageUserInfo from "./pages/users/PageUserInfo.js";
import PageReferences from "./pages/references/PageReferences.js";
import ServiceManager from "./3x1010/services/ServiceManager.js";
// test Solr
import PageSolrBlank from "./pages/SolrTest/PageSolrBlank.js";
import PageSolrFullText from "./pages/SolrTest/PageSolrFullText.js";
import PageSolrOneField from "./pages/SolrTest/PageSolrOneField.js";
import PageSolrAdvancedStandard from "./pages/SolrTest/PageSolrAdvancedStandard.js";
import PageSolrAdvanced from "./pages/SolrTest/PageSolrAdvanced.js";
import PageSolrDetail from "./pages/SolrTest/PageSolrDetail.js";
import PageSolrSimple from "./pages/SolrTest/PageSolrSimple.js";

export default class FactoryManager {
  static factory(cls) {
    return new FactoryManager.classes[cls]();
  }
}
// PAGINE
FactoryManager.classes = {
  PageCommon,
  PageDefault,
  PageGeneric,
  PageLookupGroup,
  PageLookupList,
  PageLookupDetail,
  PageUsersList,
  PageUserDetail,
  PageUserInfo,
  PageReferences,
  //test Solr
  PageSolrBlank,
  PageSolrFullText,
  PageSolrOneField,
  PageSolrAdvancedStandard,
  PageSolrAdvanced,
  PageSolrDetail,
  PageSolrSimple,
};

// ALTRE CLASSI ESPORTATE ESPLICITAMENTE
window.Class = {};
window.Class.ServiceManager = ServiceManager;
window.Class.PageCommon = PageCommon;
